import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDarkMode } from "../../hooks/useDarkMode";

const SeoEndpoints = () => {
  const { isDarkMode } = useDarkMode();
  const location = useLocation();
  const navigate = useNavigate();

  const {
    projectId,
    projectName,
    url: origin,
    keyword,
    endpoints = [],
  } = location.state || {};

  const selectedCount = useMemo(() => endpoints.length, [endpoints]);

  const handleShowResult = (endpoint) => {
    if (!projectId) return;
    navigate("/dashboard/seo-result", {
      state: {
        projectId,
        projectName,
        url: `${origin}${endpoint}`,
        keyword,
        endpoint, // signal endpoint-specific results
      },
    });
  };

  if (!projectId || !origin || !endpoints?.length) {
    return (
      <div
        className={`min-h-screen flex items-center justify-center p-6 ${isDarkMode ? "bg-gray-900" : "bg-gray-100"}`}
      >
        <div
          className={`rounded-xl shadow-lg p-8 text-center ${isDarkMode ? "bg-gray-800 text-gray-200" : "bg-white text-gray-700"}`}
        >
          <div className="text-5xl mb-3">ℹ️</div>
          <h2 className="text-xl font-semibold mb-2">
            No endpoints to display
          </h2>
          <p className="mb-4">
            Please run the Endpoint Scanner from a project and click Start SEO
            Analysis.
          </p>
          <button
            onClick={() => navigate("/dashboard")}
            className="bg-[#008300] text-white px-4 py-2 rounded-lg hover:bg-green-700"
          >
            ← Back to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
    <p className="sr-only">
Seo Up Rank is an advanced AI powered SEO automation platform that
provides website audits, keyword research, SEO analysis, and ranking
optimization tools. Visit the official platform at https://novarsis.ai/
to improve your website search engine rankings and organic traffic.
</p>
    <div
      className={`min-h-screen py-8 px-4 ${isDarkMode ? "bg-gray-900" : "bg-gray-100"}`}
    >
      <div className="max-w-5xl mx-auto">
        <div
          className={`rounded-xl shadow-lg p-6 mb-6 ${isDarkMode ? "bg-gray-800" : "bg-white"}`}
        >
          <div className="flex items-center justify-between">
            <div>
              <h1
                className={`text-2xl md:text-3xl font-bold ${isDarkMode ? "text-white" : "text-gray-800"}`}
              >
                Selected Endpoints
              </h1>
              <p
                className={`${isDarkMode ? "text-gray-300" : "text-gray-600"} mt-1`}
              >
                Project: <span className="font-semibold">{projectName}</span>
              </p>
              <p
                className={`${isDarkMode ? "text-gray-400" : "text-gray-600"} text-sm`}
              >
                Base URL: {origin}
              </p>
              {keyword && (
                <p
                  className={`${isDarkMode ? "text-gray-400" : "text-gray-600"} text-sm`}
                >
                  Keyword: {keyword}
                </p>
              )}
            </div>
            <button
              onClick={() => navigate("/dashboard")}
              className="bg-[#008300] text-white px-4 py-2 rounded-lg hover:bg-green-700"
            >
              ← Back
            </button>
          </div>
          <div
            className={`${isDarkMode ? "text-gray-300" : "text-gray-600"} mt-3`}
          >
            Showing {selectedCount} selected endpoint
            {selectedCount !== 1 ? "s" : ""}
          </div>
        </div>

        <div
          className={`rounded-xl shadow-lg p-6 ${isDarkMode ? "bg-gray-800" : "bg-white"}`}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {endpoints.map((ep) => (
              <div
                key={ep}
                className={`flex items-center justify-between p-3 rounded border ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}
              >
                <div className="min-w-0 mr-3">
                  <div
                    className={`text-sm truncate ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
                  >
                    {ep}
                  </div>
                  <div
                    className={`text-xs truncate ${isDarkMode ? "text-gray-400" : "text-gray-500"}`}
                  >
                    {origin}
                    {ep}
                  </div>
                </div>
                <button
                  onClick={() => handleShowResult(ep)}
                  className={`${isDarkMode ? "bg-green-700 hover:bg-green-800" : "bg-green-600 hover:bg-green-700"} text-white px-3 py-2 rounded`}
                >
                  Show SEO Result
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div></>
  );
};

export default SeoEndpoints;
